type ProjectConfidentiality = TestRequestRaw.Schemas.ProjectConfidentiality;

export default ProjectConfidentiality;

function strictnessLevel(projectConfidentiality: ProjectConfidentiality) {
  if (projectConfidentiality === "HIGHLY_CONFIDENTIAL") {
    return 3;
  }
  if (projectConfidentiality === "NORMAL_CONFIDENTIAL") {
    return 2;
  }
  if (projectConfidentiality === "INTERNAL") {
    return 1;
  }
  return 0;
}

export function compareConfidentiality(
  projectConfidentiality1: ProjectConfidentiality,
  projectConfidentiality2: ProjectConfidentiality,
) {
  return strictnessLevel(projectConfidentiality2) - strictnessLevel(projectConfidentiality1);
}
